import React, { PropsWithChildren, useEffect } from 'react'
import { Center } from '../../parts/bases/Center'
import { VStack } from '../../parts/bases/VStack'
import { PinkNeonButton } from '../../parts/buttons/PinkNeonButton'
import { Spinner } from '../../parts/commons/Spinner'
import { useRouter } from 'next/router'
import { PagePathService } from '@/src/services/PagePathService'
import { LocalStorageService } from '@/src/services/LocalStorageService'

export type Props = {
  type: 'Loading' | 'LoggedIn' | 'NO_Login'
  onClickLogin: () => void
}

export const Layout = ({ children, type, onClickLogin }: PropsWithChildren<Props>) => {
  return (
    <>
      {type === 'LoggedIn' ? (
        children
      ) : type === 'Loading' ? (
        <Center className="h-full w-full">
          <Spinner visible size={40} />
        </Center>
      ) : LocalStorageService.loadAccountLock() ? (
        <Redirecter path={PagePathService.accountLocked()} />
      ) : type === 'NO_Login' ? (
        <Center className="h-full w-full">
          <VStack className="w-[500px] items-center rounded-2xl border-2 border-neon-blue bg-black bg-opacity-50 p-10">
            <h1 className="mb-4 text-xl text-white">Please login</h1>
            <PinkNeonButton onClick={onClickLogin}>Login Page</PinkNeonButton>
          </VStack>
        </Center>
      ) : null}
    </>
  )
}

const Redirecter = (props: { path: string }) => {
  const router = useRouter()
  useEffect(() => {
    router.push(props.path)
  }, [router, props.path])
  return null
}
